import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL fragment
      const hash = window.location.hash;
      const sessionId = hash.split('session_id=')[1]?.split('&')[0];

      if (!sessionId) {
        console.error('No session_id found');
        navigate('/auth');
        return;
      }

      try {
        // Exchange session_id for user data
        const response = await fetch(
          'https://demobackend.emergentagent.com/auth/v1/env/oauth/session-data',
          { headers: { 'X-Session-ID': sessionId } }
        );

        if (!response.ok) throw new Error('Failed to get session data');

        const userData = await response.json();

        // Store session in our backend
        const backendResponse = await fetch(`${API}/api/auth/google`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({
            email: userData.email,
            name: userData.name,
            picture: userData.picture,
            session_token: userData.session_token
          })
        });

        if (!backendResponse.ok) throw new Error('Backend auth failed');

        const user = await backendResponse.json();
        
        // Store token and update auth context
        localStorage.setItem('token', user.token);
        setUser(user.user);

        // Redirect based on role
        const routes = {
          founder: '/founder-dashboard',
          investor: '/investor-dashboard',
          startup: '/governance',
          mentor: '/mentors',
          admin: '/admin'
        };
        navigate(routes[user.user.role] || '/governance', { state: { user: user.user } });

      } catch (error) {
        console.error('Auth error:', error);
        navigate('/auth?error=auth_failed');
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-green-500 border-t-transparent mx-auto mb-4"></div>
        <p className="text-white text-lg">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
